export default __webpack_public_path__ + "static/media/Logo.f169a217.png";